import { UserDataVm } from './viewModel';
import { EditInformation } from '../../models/api-client';

const createUserDataVm = (): UserDataVm => ({
  nameOrCompany: '',
  additionalText: '',
  street: '',
  country: '',
  zip: '',
  city: '',
  phoneBusiness: '',
  phoneAlternative: '',
  fax: '',
  email: '',
  website: '',
});


const mapEditDtoToUserDataVm = (edit: EditInformation) : UserDataVm => ({
  nameOrCompany: edit.anspName,
  additionalText: edit.anspZusatztext,
  street: edit.adreStrasse,
  country: edit.adreLand,
  zip: edit.adrePlz,
  city: edit.adreOrt,
  phoneBusiness: edit.anspTelGesch,
  phoneAlternative: edit.anspTelAlternativ,
  fax: edit.anspFax,
  email: edit.anspeMail,
  website: edit.adreWebside,
});

export default {
  createUserDataVm,
  mapEditDtoToUserDataVm,
};
